import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/windows-filled';
// material
import { styled } from '@mui/system';
import { alpha } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import WorkIcon from '@material-ui/icons/Work';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 1723315;

export default function AppItemOrders() {
  const jobs = useSelector((state) => state.job);
  const total = Object.keys(jobs).length;
  const hiring = Object.keys(jobs).filter((j) => j.status === 'HIRING').length;
  return (
    <RootStyle>
      <IconWrapperStyle>
        {/* <Icon icon={windowsFilled} width={24} height={24} /> */}
        <WorkIcon />
      </IconWrapperStyle>
      <Typography variant="h3">
        {fShortenNumber(hiring)} / {fShortenNumber(total)}
      </Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Jobs
      </Typography>
    </RootStyle>
  );
}
